export default __webpack_public_path__ + "static/media/210430-Cloudxier Clients Logo-19.b81eb11f.png";